import { API_BASE_URL } from "@/config";
import type { User } from "@/types/auth";

import { apiFetch } from "../apiFetch";

async function getUser(): Promise<User> {
  const resp = await apiFetch(`${API_BASE_URL}/user/me`);
  if (!resp.ok) throw new Error("User not found");
  return resp.json();
}

export const apiUser = {
  getUser,
};
